// Heights and particles describe the visual scene, not measured cloud altitude.
export const WEATHER_CEILING_M = 8000;
export function rainAppearance(rate) {
    const value=Math.max(0,Number(rate)||0);
    if(value<.15)return {density:0,speed:0,tail:0,width:0,alpha:0};
    const strength=Math.min(1,Math.log1p(value)/Math.log1p(60));
    return {
        density:Math.min(150,18*Math.pow(value/5,.85)),
        speed:.62+.88*strength,
        tail:240+1150*strength,
        width:.6+.9*strength,
        alpha:.13+.44*strength,
    };
}

// Decode each distinct RGB once. Radar palettes repeat across thousands of
// pixels; cache exact matches without rounding intensities or changing masks.
export function decodeRainPixels(pixels, lut, unit) {
    const values=new Float32Array(pixels.length/4),colors=new Map();
    for(let i=0;i<values.length;i++) {
        const offset=i*4;if(pixels[offset+3]<45)continue;
        const key=(pixels[offset]<<16)|(pixels[offset+1]<<8)|pixels[offset+2];
        let value=colors.get(key);
        if(value===undefined){
            let distance=Infinity;value=0;
            for(const stop of lut){const d=(pixels[offset]-stop.c[0])**2+(pixels[offset+1]-stop.c[1])**2+(pixels[offset+2]-stop.c[2])**2;if(d<=distance){distance=d;value=stop.v;}}
            value=unit==='mm/h'?value:Math.max(0,(value-8)/3);colors.set(key,value);
        }
        values[i]=value;
    }
    return values;
}
